import get from 'lodash.get';
import isNil from 'lodash.isnil';
import { LABEL } from '../../../../constants/shared/TrcConstants';
import { NOT_SCORED, ON_GRADE_TEXT } from '../../../../constants/reading/TroConstants';
import { getCompletedBookResults } from '../../../../utils/reading/resultReducerHelper';

const { WCPM } = LABEL;

const getValueByUntranscribable = (value, isUntranscribable) =>
    !isUntranscribable ? value : NOT_SCORED;

export const getSelectedBookId = ({ measureResult }, bookId) => {
    if (bookId) {
        return bookId;
    }
    const completedBooks = getCompletedBookResults(measureResult);
    const selectedBook = completedBooks.find(
        ({ relativeLevel }) => relativeLevel === ON_GRADE_TEXT,
    );
    return get(selectedBook, 'bookId');
};

export const getBooksInformation = bookResults =>
    bookResults.map(
        ({
            bookId,
            vrrResult,
            bookReadingLevel,
            comprehensionResult,
            bookTitle,
            passingLevel,
            isValid,
            relativeLevel,
        }) => {
            const { accuracy, score, isUntranscribable, audioSrc } = vrrResult;
            const { score: correctResponses, maxScore: maxComprehensionResponses } =
                comprehensionResult;

            return {
                id: bookId,
                icons: '',
                level: bookReadingLevel,
                bookTitle,
                complexityLevel: relativeLevel,
                performance: getValueByUntranscribable(passingLevel, isUntranscribable),
                accuracy: getValueByUntranscribable(`${accuracy}%`, isUntranscribable),
                fluency: getValueByUntranscribable(
                    `${score} ${WCPM.toUpperCase()}`,
                    isUntranscribable,
                ),
                comprehension: !isNil(correctResponses)
                    ? `${correctResponses}/${maxComprehensionResponses}`
                    : NOT_SCORED,
                audioSrc,
                isValid,
            };
        },
    );

export const deletePunctuationCharacters = word => word.replace(/[^\w\s’']/g, '');
